import tokens from '@ui/tokens/_variables.json';
import { createGlobalStyle } from 'styled-components/macro';
import { normalize } from 'styled-normalize';

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  /*
  Use a more-intuitive box-sizing model.
  */

  *, *::before, *::after {
    box-sizing: border-box;
  }

  /*
  Removes the default spacing for appropriate elements.
  */

  blockquote, dl, dd, h1, h2, h3, h4, h5, h6, hr, figure, p, pre {
    margin: 0;
  }

  fieldset {
    margin: 0;
    padding: 0;
  }

  legend {
    padding: 0;
  }

  ol, ul, menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  /*
  1. Make replaced elements 'display: block' by default. (https://github.com/mozdevs/cssremedy/issues/14)
  2. Add 'vertical-align: middle' to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
     This can trigger a poorly considered lint error in some tools but is included by design.
  */

  img, svg, video, canvas, audio, iframe, embed, object {
    display: block; /* 1 */
    vertical-align: middle; /* 2 */
  }

  /*
  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
  */

  img, video {
    max-width: 100%;
    height: auto;
  }

  /*
  Ensure the default browser behavior of the 'hidden' attribute.
  */

  [hidden] {
    display: none;
  }

  /*
  Create a new stacking context for the react root
  */
  #root {
    isolation: isolate;
  }

  /*
  Avoid text overflows
  */
  p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
  }

  /*
  Reset table styles
  */

  table {
    caption-side: bottom;
    border-collapse: collapse;
  }

  th {
    text-align: inherit;
    text-align: -webkit-match-parent;
  }

  thead, tbody, tfoot, tr, td, th {
    border-color: inherit;
    border-style: solid;
    border-width: 0;
  }

  /*
  Space Grotesk latin regular variable font
  https://github.com/majodev/google-webfonts-helper/issues/97
  */

  @font-face {
    font-family: 'Space Grotesk';
    font-style: normal;
    font-weight: 300 700;
    src: url(https://fonts.gstatic.com/s/spacegrotesk/v6/V8mDoQDjQSkFtoMM3T6r8E7mPbF4C_k3HqU.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    font-display: swap;
  }

  /*
  Inter latin regular variable font
  https://github.com/majodev/google-webfonts-helper/issues/97
  */

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 300 700;
    src: url(https://fonts.gstatic.com/s/inter/v7/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    font-display: swap;
  }

  html {
  display: flex;
  align-items: center;
  justify-content: center;
  }

  /*
  Apply default font styling
  */

  body {
    /* Set bg colour to body as the VE pageContainers typically have 
    margins on wider viewports that would otherwise be mismatched. */
    background-color: ${tokens.page.color.background};
    font-family: 'Inter', sans-serif;
    font-weight: var(--font-weight-normal);
    line-height: var(--line-height-normal);
    color: var(--color-black);
    -webkit-font-smoothing: antialiased;
    width: 100%;
  }
  body:has(dialog[open]) {
    /* fix small layout shift */
    height: 100vh;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Space Grotesk', sans-serif;
  }
`;
